import React, { useState, useEffect } from "react";
import { Book, Clock, CheckCircle, ChevronRight } from "lucide-react";
import { useNavigate, useLocation } from "react-router-dom";
import TopBar from "../components/TopBar";
import './css/Homework.css';
import axios from "./../axios";

const Homework = ({ setSideBar, setSettingDrawer }) => {
  const navigate = useNavigate();
  const location = useLocation();
  const [selectedSubject, setSelectedSubject] = useState("All");
  const [assignments, setAssignments] = useState({});
  const [subjects, setSubjects] = useState([]);
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    const fetchData = async () => {
      try {
        setIsLoading(true);
        const token = localStorage.getItem("student_token");

        const [subjectsResponse, assignmentsResponse] = await Promise.all([
          axios.get('student/subjects', {
            headers: { Authorization: `Bearer ${token}` },
          }),
          axios.get('student/assignments', {
            headers: { Authorization: `Bearer ${token}` },
          }),
        ]);

        const fetchedSubjects = [{ name: 'All' }, ...subjectsResponse.data];
        setSubjects(fetchedSubjects);
        setAssignments(assignmentsResponse.data);
        
        const autoopen = location.state?.autoopen;
        if (autoopen && fetchedSubjects.some(subject => subject.name === autoopen)) {
          setSelectedSubject(autoopen);
        }
      } catch (error) {
        console.error('Error fetching data:', error);
      } finally {
        setIsLoading(false);
      }
    };

    fetchData();
  }, [location.state]);

  const getDisplayedAssignments = () => {
    if (selectedSubject === "All") {
      return Object.values(assignments)
        .flat()
        .sort((a, b) => b.id - a.id); // Sort by id in descending order
    }
    return assignments[selectedSubject] || [];
  };

  return (
    <>
      <TopBar title="Homework" setSideBar={setSideBar} setSettingDrawer={setSettingDrawer} />
      <div className="homework-container">
        <div className="homework-header">
          <Book size={20} className="header-icon" />
          <h2>{selectedSubject} Assignments</h2>
        </div>
        {isLoading ? (
          <div className="skeleton-loader">
            <div className="subject-tabs">
              {[...Array(4)].map((_, i) => (
                <div key={i} className="skeleton-tab"></div>
              ))}
            </div>
            <div className="assignment-list">
              {[...Array(3)].map((_, i) => (
                <div key={i} className="assignment-item skeleton-assignment">
                  <div className="assignment-icon skeleton-icon"></div>
                  <div className="assignment-content">
                    <div className="assignment-title skeleton-title"></div>
                    <div className="assignment-meta">
                      <div className="skeleton-meta"></div>
                    </div>
                  </div>
                </div>
              ))}
            </div>
          </div>
        ) : (
          <>
            <div className="subject-tabs">
              {subjects.map((subject) => (
                <div
                  key={subject.name}
                  className={`tab ${selectedSubject === subject.name ? "active" : ""}`}
                  onClick={() => setSelectedSubject(subject.name)}
                >
                  {subject.name}
                </div>
              ))}
            </div>
         
            <div className="assignment-list">
              {getDisplayedAssignments().map((assignment) => (
                <div
                  key={assignment.id}
                  className="assignment-item"
                  onClick={() => navigate(`/student/homework/${assignment.id}`)}
                >
                   {!assignment.read ? (
    <div className="subject-dot"></div>

    ):null}
                  <div className="assignment-icon">
                    <Book size={18} />
                  </div>
                  <div className="assignment-content">
                    <span className="assignment-title">{assignment.title}</span>
                    <div className="assignment-meta">
                      <span className="due-date">
                        <Clock size={14} />  {new Date(assignment.time).toISOString().split('T')[0]}
                      </span>
                      <span className="status">
                        <CheckCircle size={14} />
                        {assignment.completed ? "Completed" : "Pending"}
                      </span>
                    </div>
                  </div>
                  <ChevronRight size={18} className="chevron" />
                </div>
              ))}
              {getDisplayedAssignments().length === 0 && (
                <div className="no-assignments">No assignments for {selectedSubject}</div>
              )}
            </div>
          </>
        )}
      </div>
    </>
  );
};

export default Homework;